<template>
  <div>
    <!-- 初期ローディング -->
    <DialogInitialLoading ref="DialogInitialLoading" />

    <!-- fnc=MTKの時はこちらで処理 -->
    <TemplateMTK ref="MTK" />

    <!-- fnc=STRの時はこちらで処理 -->
    <TemplateSTR ref="STR" />

    <!-- fnc=CPNの時はこちらで処理 -->
    <TemplateCPN ref="CPN" />

    <!-- fnc=VCHの時はこちらで処理 -->
    <TemplateVCH ref="VCH" />

    <!-- fnc=BOKの時はこちらで処理 -->
    <TemplateBOK ref="BOK" />

    <!-- fnc=PRXの時はこちらで処理 -->
    <TemplatePRX ref="PRX" />
  </div>
</template>

<script>
import TemplateMTK from "@/views/Templates/SetQR/TemplateMTK";
import TemplateSTR from "@/views/Templates/SetQR/TemplateSTR";
import TemplateCPN from "@/views/Templates/SetQR/TemplateCPN";
import TemplateVCH from "@/views/Templates/SetQR/TemplateVCH";
import TemplateBOK from "@/views/Templates/SetQR/TemplateBOK";
import TemplatePRX from "@/views/Templates/SetQR/TemplatePRX";

// Service
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "SetQR",

  components: {
    TemplateMTK: TemplateMTK,
    TemplateSTR: TemplateSTR,
    TemplateBOK: TemplateBOK,
    TemplateCPN: TemplateCPN,
    TemplateVCH: TemplateVCH,
    TemplatePRX: TemplatePRX,
  },
  data() {
    return {};
  },
  async mounted() {
    nativeHandlerService.ncAppVersion();

    // fncごとの振り分けを行う
    this.parseQuery();
  },
  methods: {
    async parseQuery() {
      switch (this.$route.query.fnc) {
        case "MTK":
          if (this.isLogin) {
            this.$refs.DialogInitialLoading.closeDialog();
            this.$refs.MTK.MTK();
          } else {
            this.$refs.STR.STR();
          }
          break;
        case "STR":
          // ストアの場合はIDのチケット詳細を開くだけ。別WebviewなのでopenTicket()
          this.$refs.STR.STR();
          break;
        case "CPN":
          if (this.isLogin) {
            this.$refs.CPN.CPN();
          } else {
            this.returnNativeAppToAccountPage();
          }
          break;
        case "VCH":
          if (this.isLogin) {
            this.$refs.DialogInitialLoading.closeDialog();
            this.$refs.VCH.VCH();
          } else {
            this.returnNativeAppToAccountPage();
          }
          break;
        case "BOK":
          if (this.isLogin) {
            this.$refs.DialogInitialLoading.closeDialog();
            this.$refs.BOK.BOK();
          } else {
            this.returnNativeAppToAccountPage();
          }
          break;
        case "PRX":
          this.$refs.PRX.PRX();
          break;
      }
    },
  },
};
</script>
